import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import Avatar from '../../Avatar/Avatar'
import './PatientFloatFilter.css'

function PatientFloatFilter({ patients = [], value, onChange }) {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (!open) return undefined
    const close = (event) => {
      if (event.target.closest?.('.patient-float-filter')) return
      setOpen(false)
    }
    const onKey = (event) => {
      if (event.key === 'Escape') setOpen(false)
    }
    document.addEventListener('mousedown', close)
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('mousedown', close)
      document.removeEventListener('keydown', onKey)
    }
  }, [open])

  if (!patients.length) return null
  const selected = patients.find((patient) => String(patient.id) === String(value)) || patients[0]
  const others = patients.filter((patient) => String(patient.id) !== String(selected?.id))

  return createPortal(
    <div className={`patient-float-filter${open ? ' is-open' : ''}`} data-onboarding="dashboard-filter">
      {open && others.length > 0 && (
        <div className="patient-float-filter-list" role="listbox" aria-label="Pacientes">
          {others.map((patient) => (
            <button
              key={patient.id}
              type="button"
              role="option"
              aria-selected={false}
              title={patient.name}
              aria-label={patient.name}
              className="patient-float-filter-avatar"
              onClick={() => {
                onChange?.(patient.id)
                setOpen(false)
              }}
            >
              <Avatar name={patient.name} imageUrl={patient.photoUrl || patient.photo_url} size="md" />
            </button>
          ))}
        </div>
      )}
      <button
        type="button"
        className="patient-float-filter-toggle"
        aria-label={selected?.name ? `Filtrar paciente, atual ${selected.name}` : 'Filtrar paciente'}
        title={selected?.name || 'Filtrar paciente'}
        aria-expanded={open}
        onClick={() => setOpen((current) => !current)}
      >
        <Avatar name={selected?.name} imageUrl={selected?.photoUrl || selected?.photo_url} size="md" />
      </button>
    </div>,
    document.body
  )
}

export default PatientFloatFilter
